import { tokens } from "../../public/tokens.js";

export const programStyles = {

    moduleCardHeader: {
        position: "relative",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-end",
        alignItems: "flex-start",
        gap: "10px",
        padding: "4px 12px",
        borderRadius: tokens.globals["border-radius"],
        flex: "1 0 0",
        alignSelf: "stretch",
        color: tokens.colors.neutral.white,
        overflow: "hidden",
        paddingBottom: "11px"
    },

    statusRow: {
        position: "relative",
        display: "flex",
        width: "100%",
        justifyContent: "space-between",
        alignItems: "flex-start",
        zIndex: 2,
        paddingTop: "6px",
    },

    statusLeft: {
        display: "flex",
        alignItems: "center",
        gap: "8px",
        flexWrap: "nowrap",
    },

    chipBase: {
        display: "flex",
        height: "18px",
        padding: "4px 8px",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: "2px",
        borderRadius: tokens.globals["border-radius"],
        fontSize: tokens.typography.fontSize["sm-10px"],
        fontWeight: tokens.typography.fontWeights.semibold,
    },

    codeIntake: {
        textAlign: "center",
        fontSize: tokens.typography.fontSize["md-12px"],
        fontStyle: "normal",
        fontWeight: tokens.typography.fontWeights.regular,
        lineHeight: "12px",
    },

    titleRow: {
        fontSize: tokens.typography.fontSize["base-16px"],
        fontStyle: "normal",
        fontWeight: tokens.typography.fontWeights.bold,
        lineHeight: "20px",
        textWrap: "pretty"
    },


    dateRow: {
        display: "flex",
        alignItems: "center",
        gap: "6px",
        textEdge: "cap",
        fontSize: tokens.typography.fontSize["md-12px"],
        fontStyle: "normal",
        fontWeight: tokens.typography.fontWeights.regular,
        lineHeight: "12px",
        fontVariantNumeric: "ordinal",
        fontFeatureSettings: "'ss05' on",
    },

    markChip: {
        display: "flex",
        minHeight: "18px",
        maxHeight: "18px",
        padding: "4px",
        alignItems: "center",
        gap: "4px",
        borderRadius: tokens.globals["border-radius"],
        textAlign: "center",
        fontFeatureSettings: "'liga' off, 'clig' off",
        fontSize: tokens.typography.fontSize["sm-10px"],
        fontStyle: "normal",
        fontWeight: tokens.typography.fontWeights.bold,
        lineHeight: "100%",
    },

    progressWrapper: {
        width: "100%",
        marginTop: "6px",
    },

    progressTrack: {
        position: "relative",
        display: "flex",
        height: "8px",
        width: "100%", 
        backgroundColor: tokens.colors.neutral.grey["200"],
        borderRadius: tokens.globals["border-radius"],
        overflow: "hidden",
    },

    progressFillLearning: {
        position: "absolute",
        left: 0,
        top: 0,
        height: "100%",
        backgroundColor: tokens.colors.brand["fresh-green"]["400"],
    },

    progressFillAssessment: {
        position: "absolute",
        left: 0,
        top: 0,
        height: "100%",
        backgroundColor: tokens.colors.brand["fresh-green"]["700"],
    },

    progressFooter: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        marginTop: "6px",
        color: tokens.colors.text.primary,
         width: "100%",
    },

    progressSection: {   
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        paddingTop: "8px",
        width: "100%",
    },

    totalProgressText: {
        fontSize: tokens.typography.fontSize["md-12px"],
        fontWeight: tokens.typography.fontWeights.medium,
    },

    legendRow: {
        display: "flex",
        alignItems: "center",
        gap: "12px",
        fontSize: tokens.typography.fontSize["md-12px"],
    },

    legendItem: {
        display: "flex",
        alignItems: "center",
        gap: "6px",
        whiteSpace: "nowrap",

    },

    dot: {
        width: "8px",
        height: "8px",
        borderRadius: "50%",
        display: "inline-block",
    },

    moduleCards: {
        display: "grid",
        gap: "20px",
        alignItems: "stretch",
    },

    moduleCard: {
        position: "relative",
        zIndex: 0,
        display: "flex",
        flexDirection: "column",
        width: "100%",
        alignItems: "flex-start",
        minHeight: "190px",
        padding: "12px 10px",
        borderRadius: tokens.globals["border-radius"],
        border: "1px solid #D7DEE8",
        background: tokens.colors.neutral.white,
        boxShadow: "0 2px 2.97px 0 rgba(125, 125, 125, 0.13)",
    },

    headerBottom: {
        position: "relative",
        marginTop: "auto",
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        width: "100%",
        zIndex: 2,
    },

    upcomingCard: {
        opacity: 0.5,
    },

    svgLayer: {
        position: "absolute",
        right: "-40px",
        bottom: "-165px",
        width: "380.596px",
        height: "429.202px",
        opacity: 0.4,
        mixBlendMode: "soft-light",
        pointerEvents: "none",
        zIndex: 0,
    },

    filterBar: {
        display: "flex",
        height: "36px",
        padding: "4px",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: tokens.globals["border-radius"],
        background: "#06172A",
        width: "fit-content",
        margin:"24px 0px 20px 0px",
    },

    pill: {
        color: tokens.colors.neutral.white,
        fontSize: tokens.typography.fontSize["md-12px"], 
        fontStyle: "normal",
        fontWeight: tokens.typography.fontWeights.semibold,
        lineHeight: "20px",
        letterSpacing: "0",
        padding: "4px 8px",
        borderRadius: "8px",
        border: 'none',
        background: 'unset',
    },

    activePill: {
        background: "rgba(248, 248, 252, 0.2)"
    },

    programHead: {
        color: "#252423",
        fontSize: tokens.typography.fontSize["3xl-24px"],
        fontWeight: tokens.typography.fontWeights.bold,
        lineHeight: tokens.typography.lineHeights["130"],
        padding: "0px 0px 4px 0px",
    },

    programInfoRow: {
        display: "flex",
        alignItems: "center",
        gap: "6px",
        color: tokens.colors.ui.foreground,
        textAlign: "left",
        fontVariantNumeric: "ordinal",
        fontFeatureSettings: "'ss05' on",
        fontSize: tokens.typography.fontSize["md-12px"],
        fontStyle: "normal",
        fontWeight: tokens.typography.fontWeights.regular,
        lineHeight: "12px",
        flexWrap: "wrap"
    }

};  